import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=cefe471a&scoped=true&"
import script from "./picture.vue?vue&type=script&lang=js&"
export * from "./picture.vue?vue&type=script&lang=js&"
import style0 from "./picture.vue?vue&type=style&index=0&id=cefe471a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefe471a",
  null
  
)

export default component.exports